import { ExpressShippingMethod } from '../types';
import {
  MappedDeliveryOptions,
  DeliverySubOption,
} from '@wix/delivery-section-checkout/types';

export function getShippingMethods(
  deliveryOptions: MappedDeliveryOptions,
  code?: string,
): ExpressShippingMethod[] | undefined {
  const { errors, deliveries } = deliveryOptions;
  const deliveryMethods = [
    ...deliveries.deliveryMethods,
    ...deliveries.pickupMethods,
  ];
  const {
    hasShippingZipCodeError,
    hasShippingSubdivisionError,
    hasShippingDestinationError,
  } = errors!;
  const hasTimeSlots = deliveryMethods.some((opt) => opt.hasTimeSlots);

  if (
    hasShippingSubdivisionError ||
    hasShippingDestinationError ||
    hasShippingZipCodeError ||
    hasTimeSlots
  ) {
    return;
  }

  const shippingMethods = deliveryMethods.map(
    ({ title, price, options, subtitle }): ExpressShippingMethod => {
      const subOption: DeliverySubOption = options[0];
      return {
        label: title,
        amount: price.toString(),
        identifier: subOption?.id,
        detail: subtitle || '',
      };
    },
  );

  const selectedShippingMethod = shippingMethods.findIndex(
    (method) => method.identifier === code,
  );

  if (selectedShippingMethod !== -1) {
    shippingMethods.unshift(
      shippingMethods.splice(selectedShippingMethod, 1)[0],
    );
  }

  return shippingMethods;
}
